import { render } from "./Users.vue?vue&type=template&id=5ffa95a7"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/admin/Users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ffa95a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ffa95a7', __exports__)) {
    api.reload('5ffa95a7', __exports__)
  }
  
  module.hot.accept("./Users.vue?vue&type=template&id=5ffa95a7", () => {
    api.rerender('5ffa95a7', render)
  })

}


export default __exports__